<template>

    <div class="container">
        <StepGuide :stepCount="1"></StepGuide>

        <!--{{this.printJob.printJobSpec}}-->

        <div class="body padding">
            <div class="centerContainer textAlignCenter">
                <span class="black">Job Reference
                    <span class="red">*</span>
                    <span class="jobReference black">{{jobReference}}</span>
                </span>
                <span>
                                   <span v-show="this.activeTab === 'weight' || this.activeTab === 'lam'"
                                         class="black rightContainer">
                                         <el-popover
                                                 placement="bottom-start"
                                                 title="Need Support?"
                                                 trigger="hover"
                                                 width="220"
                                                 class="textAlignCenter"
                                                 content="Ravensworth Client Services client.support@ravensworth.co.uk 0191 917 9331">
    <el-button slot="reference" class="borderNone"><i class="font25 el-icon-info teal paddingRight"></i></el-button>
  </el-popover>
                                       <!--<i class="font25 el-icon-info teal paddingRight"></i>-->
                </span>
                </span>
            </div>
            <!--<div class="rightContainer"><i class="icon-help red"></i>-->
            <!--</div>-->

            <h2 class="teal textAlignCenter paddingTitle">Select Print Options</h2>
            <div class="overflow">

                <el-tabs :tab-position="tabPosition" style="height: 380px;" type="border-card" v-model="activeTab">
                    <el-tab-pane name="style">
                        <span slot="label" class="textAlignCenter paddingTabs"><img class="iconSize centerContainer"
                                                                                    src="/images/PaperType.png"><div
                                class="paddingLabels">Paper <br>Style</div></span>
                        <div class="optionPadding leftContainer">
                            <el-radio-group v-model="printJob.printJobSpec.stockType" v-on:change="postPaperTypes()"
                                            id="style">
                                <el-radio-button v-for="(type) in types" :label="type" :key="type">

                                    <div class="weightWidth">
                                        <span v-if="type === 'LF23'">DURATRAN</span>
                                        <span v-else>{{type}}</span>
                                    </div>
                                </el-radio-button>
                            </el-radio-group>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="weight" :disabled="disableSelections">
                        <span slot="label" class="textAlignCenter paddingTabs"><img class="iconSize centerContainer"
                                                                                    src="/images/Weight.png"><div
                                class="paddingLabels">Paper<br> Weight</div></span>
                        <div class="optionPadding leftContainer">
                            <el-radio-group v-model="printJob.printJobSpec.stockWeight" v-on:change="postPaperWeights()"
                                            id="weight">
                                <el-radio-button v-for="(weight) in weights" :label="weight" :key="weight">
                                    <div class="weightWidth">
                                                <span>
                                                    <span v-if="weight === 'LF23'">DURATRAN</span>
                                                    <span v-if="weight === 'INTRAN'">INTRAN</span>
                                                    <span v-if="weight === 'TRU'">TRUCARD</span>
                                                    <span v-if="weight !== 'INTRAN' && weight !== 'LF23' && weight !== 'TRU'">{{weight}}</span>
                                                    <span v-if="weight !== 'INTRAN' && weight !== 'LF23' && weight !== 'TRU'">gsm</span>
                                                </span>
                                    </div>
                                    <span v-show="weight == 350" class="icon-promote red fixedPosition font25"></span>
                                    <span v-show="weight == 'LF23'"
                                          class="icon-promote red fixedPosition font25"></span>
                                </el-radio-button>
                            </el-radio-group>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="lam" class="textAlignCenter" :disabled="disableSelections">
                        <span slot="label"><img class="iconSize centerContainer" src="/images/Lamination.png"><span
                                class="paddingLabels">Finishing</span></span>

                        <div class="optionPadding">
                            <div v-for="(lamination) in laminations">
                                <el-radio-group v-model="printJob.printJobSpec.lamination"
                                                v-on:change="postLamination(lamination)">
                                    <el-radio-button :label="lamination.finishing"
                                                     :key="lamination.finishing" class="leftAlign">
                                        <div class="lamWidth"
                                             v-show="lamination.finishing == 'STANDARD' || lamination.finishing == '' || lamination.finishing === 'NONE' || lamination.finishing === 'SILK'">
                                            No Lamination
                                        </div>
                                        <div class="lamWidth" v-show="lamination.finishing == 'MATT LAM'">
                                            Matt Lamination
                                        </div>
                                        <div class="lamWidth" v-show="lamination.finishing == 'GLOSS LAM'">
                                            Gloss Lamination
                                        </div>
                                    </el-radio-button>
                                </el-radio-group>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="quantity" class="textAlignCenter">
                        <span slot="label" class="textAlignCenter iconPadding"><img class="iconSize centerContainer"
                                                                                    src="/images/Quantity.png"><div
                                class="paddingLabels">Quantity</div></span>

                        <div class="optionPadding leftContainer textAlignLeft">
                            <el-radio-group v-model="printJob.printJobSpec.quantity" v-on:change="postQuantity()">
                                <el-radio-button v-for="(quantity) in quantities" :label="quantity" :key="quantity">
                                    <div class="quantWidth">{{quantity}}</div>
                                </el-radio-button>
                            </el-radio-group>

                            <div class="marginInput">

                                <el-form :model="printJob.printJobSpec.quantity" status-icon :rules="rules"
                                         ref="printJob.printJobSpec.quantity" class="paddingInput">
                                    <el-form-item prop="quantity" class="teal">Or enter a custom quantity
                                        <el-input class="column64 paddingInput" placeholder="Or enter a custom quantity"
                                                  v-model="printJob.printJobSpec.quantity"
                                                  :disabled="quantities.length < 1" clearable
                                                  v-on:blur="postQuantity()"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane class="textAlignLeft column100" disabled>
                        <span slot="label">



                            <p class="teal font16 padding5px">Print Selections</p>

                            <div class="titleLarge leftContainer black textAlignLeft padding9">Product</div>
                            <div class="leftContainer textAlignLeft productLowercase">{{this.printJob.printJobSpec.name}}</div><br>


                            <div class="titleLarge black textAlignLeft leftContainer padding9">
                                Style
                            </div>

                            <div class="titleLarge120 textAlignLeft leftContainer textAlignLeft">
                                <span v-if="this.printJob.printJobSpec.stockType">
                                    <span v-if="this.printJob.printJobSpec.stockType === 'LF23'">
                                        Duratran
                                    </span>
                                    <span v-else>
                                    {{this.printJob.printJobSpec.stockType}}
                                    </span>
                                </span>
                                <span v-else>
                                    Not Selected
                                </span>
                            </div>

                            <div class="title black textAlignLeft leftContainer">
                                Weight
                            </div>

                            <div class="titleLarge textAlignLeft leftContainer">
                                <span v-if="!this.printJob.printJobSpec.stockType">
                                    Not Selected
                                </span>
                                <span v-if="this.printJob.printJobSpec.stockWeight === 'INTRAN' || this.printJob.printJobSpec.stockWeight === 'LF23' || this.printJob.printJobSpec.stockWeight === 'TRU'">Standard</span>
                                <span v-if="this.printJob.printJobSpec.stockWeight !== 'INTRAN' && this.printJob.printJobSpec.stockWeight !== 'LF23'  && this.printJob.printJobSpec.stockWeight !== 'TRU'  && this.printJob.printJobSpec.stockWeight !== null  && this.printJob.printJobSpec.stockWeight !== '' ">{{this.printJob.printJobSpec.stockWeight}}gsm</span>
                            </div>

                            <br>

                            <div class="titleLarge black leftContainer textAlignLeft padding9">Finishing</div>
                            <div class="leftContainer textAlignLeft titleLarge120">
                            <span v-if="this.printJob.printJobSpec.lamination === null">Not Selected</span>
                            <span v-if="this.printJob.printJobSpec.lamination === 'STANDARD' || this.printJob.printJobSpec.lamination === 'NONE' || this.printJob.printJobSpec.lamination === 'SILK'">No Lamination</span>
                            <span v-if="this.printJob.printJobSpec.lamination !== null && this.printJob.printJobSpec.lamination !== 'STANDARD' && this.printJob.printJobSpec.lamination !== 'NONE' && this.printJob.printJobSpec.lamination !== 'SILK'">
                                <span v-if="this.printJob.printJobSpec.lamination == 'GLOSS LAM'">Gloss Lamination</span>
                                <span v-if="this.printJob.printJobSpec.lamination == 'MATT LAM'">Matt Lamination</span>
                            </span>
            </div>

        <div class="title leftContainer black textAlignLeft paddingSubtitle">Quantity</div>
        <div class="titleLarge leftContainer textAlignLeft paddingSubtitle">{{this.printJob.printJobSpec.quantity}}
        </div>

        <div class="totalContainer lineHeight20">
            <div class="leftContainer priceTitle textAlignLeft black padding9">Subtotal (ex. VAT)</div>
            <span class="leftContainer priceTitle textAlignLeft black">£{{printJob.netTotalPrice}}</span>
            <br>
            <div class="leftContainer priceTitle textAlignLeft teal padding9">Total</div>
            <span class="leftContainer priceTitle textAlignLeft teal">£{{printJob.grossTotalPrice}}</span>
        </div>
        </span>
        </el-tab-pane>
        </el-tabs>

        <div class="paddingTopSmall">
                                        <span class="textAlignRight paddingRight termsText column35 rightContainer">You can
                        confirm your order before payment, including
                        any items previously added to the basket</span>
            <span class="rightContainer">
                    <el-button class="redButton ravensworthButtons"
                               :disabled="completedOrder"
                               v-on:click="next()">Continue to Checkout
                    </el-button>
                    </span>
            <div class="leftContainer textAlignCenter column25" v-show="activeTab === 'weight'">
                <p class="black">Recommended Star Buy</p>
                <div class="icon-promote red font20"></div>
            </div>
            <!--<div class="black smallPaddingLeft font12">Star Buy</div><div class="icon-promote red font20 leftContainer smallPaddingLeft"></div>-->
        </div>
    </div>
    </div>


    </div>

</template>

<script>

    import Axios from 'axios';
    import Router from '../router';
    import StepGuide from '@/components/StepGuide.vue';
    import PrintJobSelections from '@/components/PrintJobSelections.vue';

    export default {
        name: "weight",
        components: {
            StepGuide,
            PrintJobSelections
        },
        props: {
            searchParams: {},
            printJob: {}
        },
        data() {
            const validateQuantity = (rule, value, callback) => {
                if (this.printJob.printJobSpec.quantity < this.minQuantity) {
                    callback(new Error('Quantity must be over the minimum quantity of ' + this.minQuantity + ' for the product'));
                } else {
                    callback();
                }
            };
            return {
                weights: [],
                types: [],
                laminations: [],
                quantities: [],
                minQuantity: 0,
                jobReference: '',
                activeName: ['1'],
                disableSelections: false,
                tabPosition: 'top',
                activeTab: 'style',
                rules: {
                    quantity: [{
                        message: '',
                        trigger: 'blur'
                    },
                        {
                            validator: validateQuantity
                        }],
                }

            }
        },
        computed: {
            completedOrder() {
                if (this.printJob.printJobSpec.stockWeight !== null && this.printJob.printJobSpec.productRef !== null && this.printJob.printJobSpec.lamination !== null && this.printJob.printJobSpec.quantity > 0) {
                    return false
                } else {
                    return true
                }
            }
        },
        created() {

            if (typeof this.printJob === 'undefined') {
                this.printJob = JSON.parse(window.sessionStorage.getItem('_printJob'))
                console.log(this.printJob)
            }
            this.jobReference = window.sessionStorage.getItem('_propertyName')

            if (this.printJob.grossTotalPrice > 0) {
                this.completedOrder = false
            }

            console.log('PRINT JOB SPEC')
            console.log(this.printJob.printJobSpec)

            this.getPaperTypes()

            if (this.printJob.printJobSpec.stockType !== null) {
                this.getPaperWeights()
            }

            if (this.printJob.printJobSpec.stockWeight !== null && this.printJob.printJobSpec.stockType !== null) {
                this.getLamination()
            }

            if (this.printJob.printJobSpec.stockWeight !== null && this.printJob.printJobSpec.stockType !== null && this.printJob.printJobSpec.lamination !== null) {
                this.getQuantities()
            }


        },
        beforeUpdate() {
            window.sessionStorage.setItem('_printJob', JSON.stringify(this.printJob));
        },
        methods: {
            next() {
                // RIFAT NOTES: as part of the bugfix to pricing calling the endpoint again to recalc the price before moving to the next page

                if (this.printJob.printJobSpec.quantity >= this.minQuantity) {
                    console.log('greater than or min quantity')

                    const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id

                    const selectQuantity = {
                        "printJobSpec": {
                            "quantity": Number(this.printJob.printJobSpec.quantity),
                        }
                    }

                    console.log(selectQuantity)

                    Axios.put(url, selectQuantity, {
                        headers: {
                            "Content-Type": "application/json",
                            "Accept": "application/json",
                            "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                        }
                    })
                        .then(response => {
                            console.log(response)
                            this.printJob = response.data

                            this.printJob.grossTotalPrice = this.printJob.grossTotalPrice.toFixed(2)
                            this.printJob.netTotalPrice = this.printJob.netTotalPrice.toFixed(2)
                            this.printJob.vatTotalPrice = this.printJob.vatTotalPrice.toFixed(2)

                            Router.push({
                                name: 'review',
                                params: {
                                    printJob: this.printJob
                                }
                            });
                        })
                        .catch(error => {
                            if (error.response.status === 500) {
                                Router.push({
                                    name: 'error',
                                    params: {
                                        printJob: this.printJob,
                                        errorType: 'noresults',
                                        issue: 'quantities'
                                    }
                                });
                            }
                        })
                }





                // Router.push({
                //     name: 'review',
                //     params: {
                //         printJob: this.printJob
                //     }
                // });
            },

            getPaperTypes() {
                const urlStockType = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/Catalogue/FindStockTypeAsync`

                const getTypes = {
                    "id": 0,
                    "fCode": this.printJob.printJobSpec.fCode,
                    "stockType": "string",
                    "pageWidth": 0,
                    "pageHeight": 0,
                    "actualPageWidth": 0,
                    "actualPageHeight": 0,
                    "pageOrientation": "string",
                    "stockWeight": "string",
                    "lamination": "string",
                    "pageCount": 0,
                    "quantity": 0
                }

                Axios.post(urlStockType, getTypes, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        this.types = response.data
                        if (this.types.length === 0) {
                            Router.push({
                                name: 'error',
                                params: {
                                    printJob: this.printJob,
                                    errorType: 'noresults',
                                    issue: 'types'
                                }
                            });
                        }
                    })

            },
            getPaperWeights() {
                const getStocks = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/Catalogue/FindStockWeightAsync`

                const getStockTypes = {
                    "id": 0,
                    "fCode": this.printJob.printJobSpec.fCode,
                    "stockType": this.printJob.printJobSpec.stockType,
                    "pageWidth": 0,
                    "pageHeight": 0,
                    "actualPageWidth": 0,
                    "actualPageHeight": 0,
                    "pageOrientation": "string",
                    "stockWeight": "string",
                    "lamination": "string",
                    "pageCount": 0,
                    "quantity": 0
                }

                Axios.post(getStocks, getStockTypes, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        console.log(response)
                        this.weights = response.data
                        if (this.weights.length === 0) {
                            Router.push({
                                name: 'error',
                                params: {
                                    printJob: this.printJob,
                                    errorType: 'noresults',
                                    issue: 'weights'
                                }
                            });
                        }
                    })
            },
            getLamination() {
                const urlLaminations = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/Catalogue/FindLaminate`

                const getLaminations = {
                    "id": 0,
                    "fCode": this.printJob.printJobSpec.fCode,
                    "stockType": this.printJob.printJobSpec.stockType,
                    "pageWidth": 0,
                    "pageHeight": 0,
                    "actualPageWidth": 0,
                    "actualPageHeight": 0,
                    "pageOrientation": "string",
                    "stockWeight": this.printJob.printJobSpec.stockWeight,
                    "lamination": "string",
                    "pageCount": 0,
                    "quantity": 0
                }

                Axios.post(urlLaminations, getLaminations, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        console.log(response)
                        this.laminations = response.data
                        if (this.laminations.length === 0) {
                            Router.push({
                                name: 'error',
                                params: {
                                    printJob: this.printJob,
                                    errorType: 'noresults',
                                    issue: 'laminations'
                                }
                            });
                        }
                    })

            },
            getQuantities() {
                const urlQuantities = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/Catalogue/FindMinimumQuantity`

                const getQuantities = {
                    "id": 0,
                    "fCode": "string",
                    "stockType": "string",
                    "pageWidth": 0,
                    "pageHeight": 0,
                    "actualPageWidth": 0,
                    "actualPageHeight": 0,
                    "pageOrientation": "string",
                    "stockWeight": 0,
                    "productRef": this.printJob.printJobSpec.productRef,
                    "lamination": "string",
                    "pageCount": 0,
                    "quantity": 0
                }

                Axios.post(urlQuantities, getQuantities, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        this.minQuantity = response.data
                        if (this.minQuantity === 0) {
                            Router.push({
                                name: 'error',
                                params: {
                                    printJob: this.printJob,
                                    errorType: 'noresults',
                                    issue: 'quantities'
                                }
                            });
                        } else {
                            this.filterQuantity()
                        }
                    })

            },
            postPaperTypes() {
                const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id + '?resetJobSpec=true'

                console.log(url)

                const selectTypes = {
                    "printJobSpec": {
                        "stockType": this.printJob.printJobSpec.stockType,
                    }
                }

                console.log('Select type body')
                console.log(selectTypes)

                Axios.put(url, selectTypes, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        console.log(response.data.printJobSpec)
                        this.weights = []
                        this.laminations = []
                        this.quantities = []
                        this.printJob = response.data

                        console.log(this.printJob.printJobSpec.stockType)
                        // todo within here I need to get a
                        if (this.printJob.printJobSpec.stockType !== 'LF23' && this.printJob.printJobSpec.stockType !== 'INTRAN' && this.printJob.printJobSpec.stockType !== 'TRU' ) {
                            // todo do normal get the weight and show weight

                            this.getPaperWeights()
                            this.activeTab = 'weight'
                            this.disableSelections = false;
                        } else {
                            // todo move straight to quantity and disable others x2
                            this.getQuantities()
                            this.disableSelections = true;
                            this.activeTab = 'quantity';
                        }
                    })

            },
            postPaperWeights() {
                const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id

                const selectWeight = {
                    "printJobSpec": {
                        "stockWeight": this.printJob.printJobSpec.stockWeight,
                    }
                }

                console.log('select weight body')
                console.log(selectWeight)

                Axios.put(url, selectWeight, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        console.log(response)
                        this.laminations = []
                        this.quantities = []
                        console.log('quantities')
                        console.log(this.quantities)
                        this.printJob = response.data
                        this.getLamination()
                        this.activeTab = 'lam'
                    })

            },
            postLamination(lamination) {
                const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id

                console.log(url)

                const selectLamination = {
                    "printJobSpec": {
                        "lamination": this.printJob.printJobSpec.lamination,
                        "productRef": lamination.productRef
                    }
                }

                console.log('laminations')
                console.log(selectLamination)

                Axios.put(url, selectLamination, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        console.log(response)
                        this.quantity = true
                        console.log(this.quantity)
                        this.printJob = response.data
                        this.getQuantities()
                        this.activeTab = 'quantity'
                    })

            },
            postQuantity() {

                if (this.printJob.printJobSpec.quantity >= this.minQuantity) {
                    console.log('greater than or min quantity')

                    const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id

                    const selectQuantity = {
                        "printJobSpec": {
                            "quantity": Number(this.printJob.printJobSpec.quantity),
                        }
                    }

                    console.log(selectQuantity)

                    Axios.put(url, selectQuantity, {
                        headers: {
                            "Content-Type": "application/json",
                            "Accept": "application/json",
                            "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                        }
                    })
                        .then(response => {
                            console.log(response)
                            this.printJob = response.data

                            this.printJob.grossTotalPrice = this.printJob.grossTotalPrice.toFixed(2)
                            this.printJob.netTotalPrice = this.printJob.netTotalPrice.toFixed(2)
                            this.printJob.vatTotalPrice = this.printJob.vatTotalPrice.toFixed(2)
                        })
                        .catch(error => {
                            if (error.response.status === 500) {
                                Router.push({
                                    name: 'error',
                                    params: {
                                        printJob: this.printJob,
                                        errorType: 'noresults',
                                        issue: 'quantities'
                                    }
                                });
                            }
                        })
                }

            },





































            selectType() {
                console.log('select type')

                const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id + '?resetJobSpec=true'

                console.log(url)

                const selectTypes = {
                    "printJobSpec": {
                        "stockType": this.printJob.printJobSpec.stockType,
                    }
                }

                console.log('Select type body')
                console.log(selectTypes)

                Axios.put(url, selectTypes, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        console.log(response.data.printJobSpec)
                        this.weights = []
                        this.laminations = []
                        this.quantities = []
                        this.completedOrder = true
                        this.printJob = response.data



                        if (this.printJob.printJobSpec.stockType !== 'LF23' && this.printJob.printJobSpec.stockType !== 'INTRAN' && this.printJob.printJobSpec.stockType !== 'TRU' ) {

                            const getWeights = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/Catalogue/FindStockWeightAsync`

                            const getWeightsBody = {
                                "id": 0,
                                "fCode": this.printJob.printJobSpec.fCode,
                                "stockType": this.printJob.printJobSpec.stockType,
                                "pageWidth": 0,
                                "pageHeight": 0,
                                "actualPageWidth": 0,
                                "actualPageHeight": 0,
                                "pageOrientation": "string",
                                "stockWeight": "string",
                                "lamination": "string",
                                "pageCount": 0,
                                "quantity": 0
                            }

                            console.log('get weights')
                            console.log(getWeightsBody)

                            Axios.post(getWeights, getWeightsBody, {
                                headers: {
                                    "Content-Type": "application/json",
                                    "Accept": "application/json",
                                    "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                                }
                            })
                                .then(response => {
                                    this.weights = []
                                    this.weights = response.data
                                    if (this.weights.length === 0) {
                                        Router.push({
                                            name: 'error',
                                            params: {
                                                printJob: this.printJob,
                                                errorType: 'noresults',
                                                issue: 'weights'
                                            }
                                        });
                                    } else if (this.weights.length === 1) {
                                        // if (this.weights[0] === this.print)

                                        // todo needs better validation!!

                                        this.printJob.printJobSpec.stockWeight = this.weights[0]

                                        this.selectWeight()

                                    } else {
                                        this.activeTab = 'weight'
                                    }
                                })
                                .catch(error => {
                                    if (error.response.status === 500) {
                                        Router.push({
                                            name: 'error',
                                            params: {
                                                printJob: this.printJob,
                                                errorType: 'noresults',
                                                issue: 'types'
                                            }
                                        });
                                    }
                                })
                        } else {
                            //todo we need to skip and disable but call the quantitiy endpoint
                        }
                    })
            },
            selectWeight() {
                console.log('select weight')
                const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id

                const selectWeight = {
                    "printJobSpec": {
                        "stockWeight": this.printJob.printJobSpec.stockWeight,
                    }
                }

                console.log('select weight body')
                console.log(selectWeight)

                Axios.put(url, selectWeight, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        console.log(response)
                        // this.lamination = true
                        this.laminations = []
                        this.quantities = []
                        console.log('quantities')
                        console.log(this.quantities)
                        this.completedOrder = true
                        this.printJob = response.data

                        const findLaminate = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/Catalogue/FindLaminate`

                        const getTypes = {
                            "id": 0,
                            "fCode": this.printJob.printJobSpec.fCode,
                            "stockType": this.printJob.printJobSpec.stockType,
                            "pageWidth": 0,
                            "pageHeight": 0,
                            "actualPageWidth": 0,
                            "actualPageHeight": 0,
                            "pageOrientation": "string",
                            "stockWeight": this.printJob.printJobSpec.stockWeight,
                            "lamination": "string",
                            "pageCount": 0,
                            "quantity": 0
                        }

                        this.activeTab = 'lam'

                        console.log('GET TYPES')
                        console.log(getTypes)

                        Axios.post(findLaminate, getTypes, {
                            headers: {
                                "Content-Type": "application/json",
                                "Accept": "application/json",
                                "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                            }
                        })
                            .then(response => {
                                console.log('GET LAMINATION')
                                console.log(response.data)
                                this.laminations = []
                                this.laminations = response.data
                                if (this.laminations.length === 0) {
                                    console.log('no lamination results')
                                    Router.push({
                                        name: 'error',
                                        params: {
                                            printJob: this.printJob,
                                            errorType: 'noresults',
                                            issue: 'laminations'
                                        }
                                    });
                                }
                            })
                            .catch(error => {
                                if (error.response.status === 500) {
                                    console.log('500 error getting lamination')
                                    Router.push({
                                        name: 'error',
                                        params: {
                                            printJob: this.printJob,
                                            errorType: 'noresults',
                                            issue: 'weights'
                                            // todo this needs a problem creating order error
                                        }
                                    });
                                }
                            })
                    })
            },
            selectLamination(lam) {

                const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id

                console.log(url)

                const selectLamination = {
                    "printJobSpec": {
                        "lamination": this.printJob.printJobSpec.lamination,
                        "productRef": lam.productRef
                    }
                }

                console.log('laminations')
                console.log(selectLamination)

                Axios.put(url, selectLamination, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        console.log(response)
                        this.quantity = true
                        console.log(this.quantity)
                        this.printJob = response.data

                        const urlQuantities = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/Catalogue/FindMinimumQuantity`

                        const getQuantities = {
                            "id": 0,
                            "fCode": "string",
                            "stockType": "string",
                            "pageWidth": 0,
                            "pageHeight": 0,
                            "actualPageWidth": 0,
                            "actualPageHeight": 0,
                            "pageOrientation": "string",
                            "stockWeight": 0,
                            "productRef": this.printJob.printJobSpec.productRef,
                            "lamination": "string",
                            "pageCount": 0,
                            "quantity": 0
                        }

                        this.activeTab = 'quantity'

                        console.log(getQuantities)

                        Axios.post(urlQuantities, getQuantities, {
                            headers: {
                                "Content-Type": "application/json",
                                "Accept": "application/json",
                                "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                            }
                        })
                            .then(response => {
                                console.log(response)
                                this.minQuantity = response.data
                                this.filterQuantity()
                                console.log('quantity')
                                console.log(this.printJob.printJobSpec.quantity > 0)
                                if (this.printJob.printJobSpec.quantity > 0) {
                                    this.selectQuantity()
                                }
                                if (this.minQuantity.length === 0) {
                                    Router.push({
                                        name: 'error',
                                        params: {
                                            printJob: this.printJob,
                                            errorType: 'noresults',
                                            issue: 'quantities'
                                        }
                                    });
                                }
                            })
                            .catch(error => {
                                if (error.response.status === 500) {
                                    Router.push({
                                        name: 'error',
                                        params: {
                                            printJob: this.printJob,
                                            errorType: 'noresults',
                                            issue: 'laminations'
                                        }
                                    });
                                }
                            })
                    })
            },
            selectQuantity() {
                console.log('select quantities')

                if (this.printJob.printJobSpec.quantity >= this.minQuantity) {
                    console.log('greater than or min quantity')

                    const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/orders/` + this.printJob.id

                    const selectQuantity = {
                        "printJobSpec": {
                            "quantity": Number(this.printJob.printJobSpec.quantity),
                        }
                    }

                    console.log(selectQuantity)

                    Axios.put(url, selectQuantity, {
                        headers: {
                            "Content-Type": "application/json",
                            "Accept": "application/json",
                            "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                        }
                    })
                        .then(response => {

                            if (this.printJob.printJobSpec.stockWeight !== null && this.printJob.printJobSpec.productRef !== null && this.printJob.printJobSpec.lamination !== null && this.printJob.printJobSpec.quantity > 0) {
                                this.completedOrder = false
                            }
                            console.log(response)
                            this.printJob = response.data

                            this.printJob.grossTotalPrice = this.printJob.grossTotalPrice.toFixed(2)
                            this.printJob.netTotalPrice = this.printJob.netTotalPrice.toFixed(2)
                            this.printJob.vatTotalPrice = this.printJob.vatTotalPrice.toFixed(2)
                        })
                        .catch(error => {
                            if (error.response.status === 500) {
                                Router.push({
                                    name: 'error',
                                    params: {
                                        printJob: this.printJob,
                                        errorType: 'noresults',
                                        issue: 'quantities'
                                    }
                                });
                            }
                        })
                }
            },
            filterQuantity() {
                const filteringQuantities = [
                    '1',
                    '2',
                    '5',
                    '10',
                    '16',
                    '30',
                    '50',
                    '100',
                    '250',
                    '500',
                    '750',
                    '1000',
                    '2500'
                ]

                this.quantities = []

                filteringQuantities.forEach(quantity => {
                    if (quantity >= this.minQuantity) {
                        this.quantities.push(quantity)
                    }
                })


            }
        }
    };
</script>